import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "skeleton"]

  addRow() {
    const clone = this.templateTarget.content.cloneNode(true)
    this.listTarget.appendChild(clone)

    if (this.hasSkeletonTarget) {
      this.skeletonTarget.classList.add("hidden")
    }
  }

  removeRow(event) {
    const button = event.currentTarget
    const row = button.closest("article")
    row.remove()

    if (this.listTarget.querySelectorAll("article").length === 0) {
      if (this.hasSkeletonTarget) {
        this.skeletonTarget.classList.remove("hidden")
      }
    }
  }
}
